module.exports = __webpack_public_path__ + "img/three-dots-vertical.b7da6387.svg";